import React from "react";
import "./About.css";
import yara1 from "../../images/yara_about.jpeg";

const About = () => {
  return (
    <section className="sobre" id="sobre">
      <div className="sobre-content">
        <h1>Sobre mim</h1>
        <div className="sobre-image">
          <img src={yara1} alt="Yara Catarina Carreira" />
        </div>
        <h2>Yara Catarina Carreira</h2>
        <div className="sobre-text">
          <h3>
            <span style={{ color: "#ffd291", fontWeight: "700" }}>
              Advogada,
            </span>{" "}
            inscrita na OAB/PA n° 38.055, Bacharel em Direito pelo
            Centro Universitário do Estado do Pará (CESUPA) e Pós-graduada em
            Direito Penal e Criminologia pela Pontifícia Universidade Católica
            do Rio Grande do Sul (PUC-RS).
          </h3>
          <h3>
            <span style={{ color: "#ffd291", fontWeight: "700" }}>
              Minha atuação
            </span>{" "}
            é pautada pela transparência, honestidade e comprometimento em todas
            as etapas do atendimento jurídico. Prezo por uma relação verdadeira
            com o cliente, oferecendo informações claras, orientações realistas
            e acolhimento humano diante de cada situação. Mais do que resolver
            demandas, busco construir uma atuação responsável, empática e
            íntegra, garantindo que o cliente se sinta amparado, respeitado e
            plenamente informado durante todo o processo.
          </h3>
        </div>
      </div>
    </section>
  );
};

export default About;
